import { useId } from 'react';
function useUniqueId() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const id = useId();
  return `${prefix ? `${prefix}-` : ''}${id}`;
}
export default useUniqueId;